export default "__VITE_ASSET__DxShXP06__"